import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { cancelPickingsActions } from "store/ducks/pickings";

export function* cancelPickingsRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/pickings-cancel`, postData
    );

    const { data } = responseBody;
    yield put(cancelPickingsActions.success(data));
    notify("success", "Carga cancelada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(cancelPickingsActions.failure(errorMessage));
  }
}
